import { Box } from '@mui/material';
import type { ReactNode } from 'react';

import Link from '../Link';

interface Props {
  value: ReactNode | string | number | boolean;
  href?: string;
}

export default function Value({ value, href }: Props) {
  if (typeof value === 'object' && href) {
    throw new Error('href prop can be used with primitive values only');
  }

  // #FIXME: This check for ReactNode is not entirely correct.
  if (value === 'object') {
    return <>{value}</>;
  }

  if (href) {
    return <Link href={href}>{value}</Link>;
  }

  return (
    <Box
      sx={{
        fontWeight: 'regular',
      }}
    >
      {value}
    </Box>
  );
}
